import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'dark' | 'light';
};
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const boxClass = tone === 'dark' ? 'bg-navy-deep text-gold border-navy-soft' : 'bg-white text-coral border-coral/20';
  const units: {
    value: string;
    label: string;
  }[] = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-56" data-mp="3h2a9t5jxn4sx">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-57" data-mp="10clc4kxpq8az" data-mpi={index}>
          <div className={`${boxClass} flex min-w-[72px] flex-col items-center rounded-xl border px-3 py-2 shadow-card sm:min-w-[88px]`} data-id="element-58" data-mp="10cv1c6axobfm">
            <span className="font-display text-3xl font-extrabold leading-none tabular-nums sm:text-4xl" data-id="element-59" data-mp="y0n0nmoy559i">
              {unit.value}
            </span>
            <span className="mt-1 text-[11px] font-bold uppercase tracking-wider opacity-70" data-id="element-60" data-mp="t1tqo48vbwe3">
              {unit.label}
            </span>
          </div>
          {index < units.length - 1 && <span className={`font-display text-2xl ${tone === 'dark' ? 'text-gold/60' : 'text-coral/50'}`} aria-hidden="true" data-id="element-61" data-mp="12sokbtog1y9k">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}